<div class="skl-modernization-readiness" aria-busy="true" aria-label="Loading modernization readiness settings">
  <div class="skl-tabs">
    @for (tab of tabs; track tab) {
      <app-skeleton [width]="tab === 1 ? '82px' : tab === 2 ? '90px' : '104px'" height="32px" borderRadius="16px" marginBottom="0"></app-skeleton>
    }
  </div>

  <div class="skl-panel">
    <app-skeleton width="240px" height="18px" borderRadius="4px" marginBottom="12px"></app-skeleton>
    <app-skeleton width="86%" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

    <div class="skl-card">
      <div class="skl-card__body">
        <div class="skl-card-header">
          <app-skeleton width="240px" height="18px" borderRadius="4px" marginBottom="0"></app-skeleton>
          <div class="skl-card-actions">
            <app-skeleton width="72px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
            <app-skeleton width="108px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
            <app-skeleton width="96px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
          </div>
        </div>

        <div class="skl-summary-block">
          <app-skeleton width="210px" height="13px" borderRadius="3px" marginBottom="14px"></app-skeleton>
          <app-skeleton width="100%" height="180px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>

        <div class="skl-field-row">
          @for (row of summaryRows; track row) {
            <div>
              <app-skeleton width="160px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
              <app-skeleton [height]="row === 1 ? '40px' : row === 2 ? '180px' : '72px'" width="100%" borderRadius="4px" marginBottom="0"></app-skeleton>
            </div>
          }
        </div>

        <div class="skl-footer-actions">
          <app-skeleton width="132px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
          <app-skeleton width="104px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    </div>

    <div class="skl-card">
      <div class="skl-card__body">
        <app-skeleton width="280px" height="18px" borderRadius="4px" marginBottom="14px"></app-skeleton>
        <app-skeleton width="72%" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>

        <div class="skl-stats-grid">
          @for (stat of stats; track stat) {
            <div class="skl-stat-card">
              <app-skeleton width="62%" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
              <app-skeleton width="46%" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>